<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="turma">
        <th mat-header-cell *matHeaderCellDef> Descrição </th>
        <td mat-cell *matCellDef="let element"> {{element.turma.descricao}} </td>
    </ng-container>

    <ng-container matColumnDef="niveis">
        <th mat-header-cell *matHeaderCellDef> Níveis da turma </th>
        <td mat-cell *matCellDef="let element"> {{element.turma.niveisTurma.descricao}} </td>
    </ng-container>

    <ng-container matColumnDef="turno">
        <th mat-header-cell *matHeaderCellDef> Turno </th>
        <td mat-cell *matCellDef="let element"> {{element.turma.turno}} </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta && element.turma && !element.turma.idPlanejamentoOficina" mat-button (click)="deletar(element)">
                <mat-icon matTooltip="excluir">delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar nova turma" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
